import ChatBox from "./ChatBox"
import "./App.css"

function App() {
  return (
    <div className="app-container">
      <h1>AI Chatbot</h1>
      <ChatBox />
    </div>
  )
}

export default App
